import React from 'react';
import styled from "styled-components"
import LineDivider from '../LineDivider'

const AccountBalance = ({liabilitiesAccountBalance}) => {
    const showAccountBalance = ()=>{
        return liabilitiesAccountBalance.map((account,i)=>{
            return(
                <React.Fragment key={i}>
                    <AccountDetail>
                        <div className = "account-detail-header">
                            <div>
                                Account Name & Number
                            </div>
                            <div className="value">
                                {account.customerName} - {account.accountNumber}
                            </div>
                        </div>
                        <div className="account-detail-footer">
                            <div>
                                <div>
                                    Account Type 
                                </div>
                                <div className="value">
                                    {account.type}
                                </div>
                            </div>
                            <div>
                                <div>
                                    Balance
                                </div>
                                <div className="value">
                                    Rs. {account.accountBalance}
                                </div>
                            </div>
                        </div>
                    </AccountDetail>
                    {i!==liabilitiesAccountBalance.length - 1 && <LineDivider />}
                </React.Fragment>
            )
        });
    }
    return (
        <React.Fragment>
            {showAccountBalance()}
        </React.Fragment>
    );
};

const AccountDetail = styled.div`
    display:flex;
    flex-direction : column;
    margin-top : 15px;
    & .account-detail-footer{
        display:flex;
        margin-top : 10px;
        >div:first-child{
            margin-right:15px;
        }
    }
    & .value{
        margin-top : 3px;
        font-weight: 500;
        color: #2c387a;
    }
`

export default AccountBalance;